import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import AddSystemPage from "./pages/AddSystemPage";
import EditSystemPage from "./pages/EditSystemPage";
import NewBooksPage from "./pages/NewBooksPage";
import AuthorsPage from "./pages/AuthorsPage";
import AddCoursePage from "./pages/AddCoursePage";
import ProtectedRoute from "./auth/ProtectedRoute";

function App() {
  // Get the base URL from the homepage in package.json or default to "/"
  const basename = process.env.PUBLIC_URL;
  
  return (
    <Router basename={basename}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } />
        <Route path="/course/new" element={
          <ProtectedRoute>
            <AddCoursePage />
          </ProtectedRoute>
        } />
        <Route path="/course/:id/edit" element={
          <ProtectedRoute>
            <EditSystemPage />
          </ProtectedRoute>
        } />
        <Route path="/discover" element={
          <ProtectedRoute>
            <NewBooksPage />
          </ProtectedRoute>
        } />
        <Route path="/instructors" element={
          <ProtectedRoute>
            <AuthorsPage />
          </ProtectedRoute>
        } />
        {/* Keep the old route for backwards compatibility, will redirect in component */}
        <Route path="/book/new" element={
          <ProtectedRoute>
            <AddSystemPage />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
